/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import ProgressBarIndicator from './ProgressBarIndicator/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Progress/Content"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtProgresscontentBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ProgressContent.borderColor.primary.base'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z1Yf8zk': dtProgresscontentBordercolorPrimaryBase,'--w-3-Z1Yf8zk': isMedia.mobile ? "75%" : "80%"}}
 className={`views-block ${styles.Vertical}`}
>
<ProgressBarIndicator
  viewPath={`${viewPath}/ProgressBarIndicator`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-3-Z1Yf8zk': isMedia.mobile ? "25%" : "20%"}}
 className={`views-block ${styles.Vertical1}`}
>
<Action
  viewPath={`${viewPath}/Action`}
/>
</div>
</div>
{children}
</React.Fragment>)
}